(function () {
  function initHero(root) {
    if (!root || root.dataset.orelvonReady === "true") return;
    root.dataset.orelvonReady = "true";

    var slidesContainer = root.querySelector("[data-product-slides]");
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-product-slide]"));
    var currentLabel = root.querySelector("[data-feature-current]");
    var totalLabel = root.querySelector("[data-feature-total]");
    var featureLabel = root.querySelector("[data-feature-label]");
    var progress = root.querySelector("[data-feature-progress]");
    var productInterval = Math.max(3000, parseInt(root.dataset.productInterval, 10) || 5000);
    var currentIndex = 0;
    var productTimer;

    root.style.setProperty("--orelvon-product-duration", productInterval + "ms");
    if (totalLabel) totalLabel.textContent = String(slides.length);

    function restartProgress() {
      if (!progress) return;
      progress.classList.remove("is-running");
      void progress.offsetWidth;
      progress.classList.add("is-running");
    }

    function showSlide(nextIndex) {
      if (!slides.length) return;
      currentIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, index) {
        slide.classList.toggle("is-active", index === currentIndex);
        slide.setAttribute("aria-hidden", index === currentIndex ? "false" : "true");
      });
      if (currentLabel) currentLabel.textContent = String(currentIndex + 1);
      if (featureLabel) {
        featureLabel.textContent = (root.dataset.featureLabel || "") + " #" + (currentIndex + 1);
      }
      restartProgress();
    }

    function stopRotation() {
      if (productTimer) window.clearInterval(productTimer);
      productTimer = null;
    }

    function startRotation() {
      stopRotation();
      if (slides.length < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      productTimer = window.setInterval(function () {
        showSlide(currentIndex + 1);
      }, productInterval);
    }

    function refreshProducts() {
      stopRotation();
      slides = Array.prototype.slice.call(root.querySelectorAll('[data-product-slide]'));
      currentIndex = 0;
      if (totalLabel) totalLabel.textContent = String(slides.length);
      if (slides.length) {
        showSlide(0);
        startRotation();
      }
    }
    var card = root.querySelector('.orelvon-feature-card');
    if (card) {
      card.addEventListener('mouseenter', stopRotation);
      card.addEventListener('mouseleave', startRotation);
      card.addEventListener('focusin', stopRotation);
      card.addEventListener('focusout', startRotation);
    }
    root.addEventListener('orelvon:products-updated', refreshProducts);
    refreshProducts();

    var offer = root.querySelector("[data-offer-popup]");
    var offerClose = root.querySelector("[data-offer-close]");
    var offerCopy = root.querySelector("[data-offer-copy]");
    var toast = root.querySelector("[data-hero-toast]");
    var toastTimer;

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add("is-visible");
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toast.classList.remove("is-visible");
      }, 2600);
    }

    if (offer) {
      var offerDelay = Math.max(0, parseInt(root.dataset.offerDelay, 10) || 0);
      window.setTimeout(function () {
        offer.hidden = false;
      }, offerDelay);
    }

    if (offerClose && offer) {
      offerClose.addEventListener("click", function () {
        offer.hidden = true;
      });
    }

    if (offerCopy) {
      offerCopy.addEventListener("click", function () {
        var code = offerCopy.dataset.offerCode || "";
        if (code && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).catch(function () {});
        }
        showToast(code ? "Discount code " + code + " copied." : "Offer saved.");
        if (offer) offer.hidden = true;
      });
    }

    root.addEventListener("orelvon:pause", stopRotation);
  }

  function initAll(container) {
    var scope = container || document;
    if (scope.matches && scope.matches("[data-orelvon-hero]")) initHero(scope);
    Array.prototype.forEach.call(scope.querySelectorAll("[data-orelvon-hero]"), initHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  if (!window.orelvonThemeEditorEventsBound) {
    window.orelvonThemeEditorEventsBound = true;
    document.addEventListener("shopify:section:load", function (event) {
      initAll(event.target);
    });
    document.addEventListener("shopify:section:unload", function (event) {
      var root = event.target.querySelector("[data-orelvon-hero]");
      if (root) root.dispatchEvent(new CustomEvent("orelvon:pause"));
    });
    document.addEventListener("shopify:block:select", function (event) {
      var slide = event.target.closest && event.target.closest("[data-product-slide]");
      if (!slide) return;
      var root = slide.closest("[data-orelvon-hero]");
      if (!root) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll("[data-product-slide]"));
      slides.forEach(function (item, index) {
        item.classList.toggle("is-active", item === slide);
        item.setAttribute("aria-hidden", item === slide ? "false" : "true");
        if (item === slide) {
          var current = root.querySelector("[data-feature-current]");
          if (current) current.textContent = String(index + 1);
        }
      });
      root.dispatchEvent(new CustomEvent("orelvon:pause"));
    });
  }
})();


